<div id="inputBlocker">
</div>